'use strict';

/**
 * TagList
 *
 * @author Srdan Turudic <srdan.turudic@namics.com>
 */
T.Module.TagList = T.createModule({

	_selectors: {
		// …
	},

	_stateClasses: {
		// …
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		// Data
		// …

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));

		// …

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {}
});